import { AxiosResponse, isAxiosError } from 'axios';
import { createLogger } from 'logging';

import { ProcessRefund201Response, RecurlyTransaction, Transactions } from '@videoblocks/subscription-service-client';
import { TransactionApiProcessRefundRequest } from '@videoblocks/subscription-service-client/api/transaction-api';

import { transactionApi } from './subscriptionServiceConfig';

const logger = createLogger('TransactionsApi');

const getHistoricTransactionsByUserId = async (userId: number): Promise<Transactions> => {
    const result = await transactionApi.getHistoricTransactionsByUserId({ userId });
    return result.data;
};

const getRecurlyTransactionsByUserId = async (userId: number): Promise<RecurlyTransaction[]> => {
    const result = await transactionApi.getRecurlyTransactionsByUserId({ userId });
    return result.data;
};

const processRefund = async (
    requestParameters: TransactionApiProcessRefundRequest,
): Promise<ProcessRefund201Response | Record<string, unknown>> => {
    try {
        const result = await transactionApi.processRefund(requestParameters);
        return result.data;
    } catch (e: unknown) {
        if (isAxiosError(e)) {
            if (e.response?.status === 400) {
                logger.warn({ error: e.message }, 'Error refunding transaction');
                return e.response?.data as Record<string, unknown>;
            }
        }
        throw e;
    }
};

export const TransactionsApi = {
    getHistoricTransactionsByUserId,
    getRecurlyTransactionsByUserId,
    processRefund,
};
